import type { QuoteCancelRequest } from 'apiConnector/quote';
import { quoteApiConnector } from 'apiConnector/quote';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, ignoreElements, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';

export function essentialCancelQuoteEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('QUOTE_CANCELLED'),
      filter(action => action.workspace === 'essential'),
      mergeMap(({ negotiationId, quoteId, productSubtype, productType }) => {
        const request = {
          negotiationId,
          quoteId,
          productSubtype,
          screenMode: 'essential',
          productType,
        } satisfies QuoteCancelRequest;

        return quoteApiConnector(httpClient)
          .cancelQuote(request)
          .pipe(
            ignoreElements(),
            catchError(() => {
              return EMPTY;
            }),
          );
      }),
    );
}
